import CustomersListItem from './CustomersListItem';
export default CustomersListItem;
